const SUPERSCRIPT = {
  0: "⁰",
  1: "¹",
  2: "²",
  3: "³",
  4: "⁴",
  5: "⁵",
  6: "⁶",
  7: "⁷",
  8: "⁸",
  9: "⁹",
};

// Render an integer as Unicode superscript digits (12 -> "¹²").
export function superscript(n) {
  return String(n)
    .split("")
    .map((d) => SUPERSCRIPT[d] || d)
    .join("");
}
